export const premium = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber',
    'Aerodynamic Profile Design for Clear Vision during High-Speed Driving'
  ],
  'material': [
    'Rubber: Nature Rubber',
    'Steel: SGCC, Electrostatic Powder Coating',
    'Rivet: SUS302ES',
    'Plastic (Spacer & Adapter): POM ',
    'Stainless Steel Backing: SUS304ES'
  ],
  'featureIcons': ['02', '03', '06'],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "12", "mm": "300", "claw": "4", "width": "6", "thickness": "1.0" },
    { "inch": "13", "mm": "325", "claw": "4", "width": "6", "thickness": "1.0" },
    { "inch": "14", "mm": "350", "claw": "4", "width": "6", "thickness": "1.0" },
    { "inch": "15", "mm": "375", "claw": "6", "width": "6", "thickness": "1.0" },
    { "inch": "16", "mm": "400", "claw": "6", "width": "6", "thickness": "1.2" },
    { "inch": "17", "mm": "425", "claw": "6", "width": "6", "thickness": "1.2" },
    { "inch": "18", "mm": "450", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "19", "mm": "475", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "20", "mm": "500", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "21", "mm": "530", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "22", "mm": "560", "claw": "8", "width": "6", "thickness": "1.2" },
    { "inch": "24", "mm": "600", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "26", "mm": "650", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "28", "mm": "700", "claw": "8", "width": "8", "thickness": "1.2" }
  ],
  "adapters": ["b1", "b3", "d2", "d4", "g1", "p", "s", "s1"]
}
